function removeZeroLengthObjectProperties(object) {
  return Object.fromEntries(
    Object.entries(object).filter(([_, propertyValue]) => {
      return (propertyValue ?? '').length;
    }),
  );
}

export default removeZeroLengthObjectProperties;
